import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import MpesaDocs from './pages/integrations/Mpesa';
import RevenueDocs from './pages/integrations/Revenue';
import SystemsInstallation from './pages/services/SystemsInstallation';
import OfficeSetup from './pages/services/OfficeSetup';
import WiFiSetup from './pages/services/WiFiSetup';
import CCTVSetup from './pages/services/CCTVSetup';
import SoftwareSystems from './pages/services/SoftwareSystems';
import Cybersecurity from './pages/services/Cybersecurity';
import HardwareMaintenance from './pages/services/HardwareMaintenance';
import FirmwareAutomation from './pages/services/FirmwareAutomation';
import Blockchain from './pages/services/Blockchain';
import WebDevelopment from './pages/services/WebDevelopment';
import MobileAppDevelopment from './pages/services/MobileAppDevelopment';
import PaymentsIntegration from './pages/services/PaymentsIntegration';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/systems-installation" element={<SystemsInstallation />} />
          <Route path="/services/office-setup" element={<OfficeSetup />} />
          <Route path="/services/wifi-setup" element={<WiFiSetup />} />
          <Route path="/services/cctv-setup" element={<CCTVSetup />} />
          <Route path="/services/software-systems" element={<SoftwareSystems />} />
          <Route path="/services/cybersecurity" element={<Cybersecurity />} />
          <Route path="/services/hardware-maintenance" element={<HardwareMaintenance />} />
          <Route path="/services/firmware-automation" element={<FirmwareAutomation />} />
          <Route path="/services/blockchain" element={<Blockchain />} />
          <Route path="/services/web-development" element={<WebDevelopment />} />
          <Route path="/services/mobile-development" element={<MobileAppDevelopment />} />
          <Route path="/services/payments-integration" element={<PaymentsIntegration />} />
          <Route path="/integrations/mpesa" element={<MpesaDocs />} />
          <Route path="/integrations/revenue" element={<RevenueDocs />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
